webpackJsonp([83],{

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1357), __esModule: true };

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1358);


/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var get = __webpack_require__(145);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 1375:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download

(function (root, factory) {
	if (true) {
		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like environments that support module.exports,
		// like Node.
		module.exports = factory();
	} else {
		// Browser globals (root is window)
		root.download = factory();
  }
}(this, function () {

	return function download(data, strFileName, strMimeType) {

		var self = window, // this script is only for browsers anyway...
			defaultMime = "application/octet-stream", // this default mime also triggers iframe downloads
			mimeType = strMimeType || defaultMime,
			payload = data,
			url = !strFileName && !strMimeType && payload,
			anchor = document.createElement("a"),
			toString = function(a){return String(a);},
			myBlob = (self.Blob || self.MozBlob || self.WebKitBlob || toString),
			fileName = strFileName || "download",
			blob,
			reader;
			myBlob= myBlob.call ? myBlob.bind(self) : Blob ;
	  
		if(String(this)==="true"){ //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
			payload=[payload, mimeType];
			mimeType=payload[0];
			payload=payload[1];
		}


		if(url && url.length< 2048){ // if no filename and no mime, assume a url was passed as the only argument
			fileName = url.split("/").pop().split("?")[0];
			anchor.href = url; // assign href prop to temp anchor
		  	if(anchor.href.indexOf(url) !== -1){ // if the browser determines that it's a potentially valid url path:
        		var ajax=new XMLHttpRequest();
        		ajax.open( "GET", url, true);
        		ajax.responseType = 'blob';
        		ajax.onload= function(e){ 
				  download(e.target.response, fileName, defaultMime);
				};
        		setTimeout(function(){ ajax.send();}, 0); // allows setting custom ajax headers using the return:
			    return ajax;
			} // end if valid url?
		} // end if url?


		//go ahead and download dataURLs right away
		if(/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)){
		
			if(payload.length > (1024*1024*1.999) && myBlob !== toString ){
				payload=dataUrlToBlob(payload);
				mimeType=payload.type || defaultMime;
			}else{			
				return navigator.msSaveBlob ?  // IE10 can't do a[download], only Blobs:
					navigator.msSaveBlob(dataUrlToBlob(payload), fileName) :
					saver(payload) ; // everyone else can save dataURLs un-processed
			}
			
		}else{//not data url, is it a string with special needs?
			if(/([\x80-\xff])/.test(payload)){			  
				var i=0, tempUiArr= new Uint8Array(payload.length), mx=tempUiArr.length;
				for(i;i<mx;++i) tempUiArr[i]= payload.charCodeAt(i);
			 	payload=new myBlob([tempUiArr], {type: mimeType});
			}		  
		}
		blob = payload instanceof myBlob ?
			payload :
			new myBlob([payload], {type: mimeType}) ;


		function dataUrlToBlob(strUrl) {
			var parts= strUrl.split(/[:;,]/),
			type= parts[1],
			decoder= parts[2] == "base64" ? atob : decodeURIComponent,
			binData= decoder( parts.pop() ),
			mx= binData.length,
			i= 0,
			uiArr= new Uint8Array(mx);

			for(i;i<mx;++i) uiArr[i]= binData.charCodeAt(i);

			return new myBlob([uiArr], {type: type});
		 }

		function saver(url, winMode){

			if ('download' in anchor) { //html5 A[download]
				anchor.href = url;
				anchor.setAttribute("download", fileName);
				anchor.className = "download-js-link";
				anchor.innerHTML = "downloading...";
				anchor.style.display = "none";
				document.body.appendChild(anchor);
				setTimeout(function() {
					anchor.click();
					document.body.removeChild(anchor);
					if(winMode===true){setTimeout(function(){ self.URL.revokeObjectURL(anchor.href);}, 250 );}
				}, 66);
				return true;
			}

			// handle non-a[download] safari as best we can:
			if(/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
				if(/^data:/.test(url))	url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
				if(!window.open(url)){ // popup blocked, offer direct download:
					if(confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")){ location.href=url; }
				}
				return true;
			}

			//do iframe dataURL download (old ch+FF):
			var f = document.createElement("iframe");
			document.body.appendChild(f);

			if(!winMode && /^data:/.test(url)){ // force a mime that will download:
				url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
			}
			f.src=url;
			setTimeout(function(){ document.body.removeChild(f); }, 333);

		}//end saver




		if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
			return navigator.msSaveBlob(blob, fileName);
		}

		if(self.URL){ // simple fast and modern way using Blob and URL:
			saver(self.URL.createObjectURL(blob), true);
		}else{
			// handle non-Blob()+non-URL browsers:
			if(typeof blob === "string" || blob.constructor===toString ){
				try{
					return saver( "data:" +  mimeType   + ";base64,"  +  self.btoa(blob)  );
				}catch(y){
					return saver( "data:" +  mimeType   + "," + encodeURIComponent(blob)  );
				}
			}

			// Blob but not URL support:
			reader=new FileReader();
			reader.onload=function(e){
				saver(this.result);
			};
			reader.readAsDataURL(blob);
		}
		return true;
	}; /* end download() */
}));


/***/ }),

/***/ 1527:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return taskTypes; });
var taskTypes = {
  BATCH_OPEN_TASK_GROUP_BY_SEARCH: { value: 56, label: '按搜索结果异步开启目标数' },
  BATCH_CLOSE_TASK_GROUP_BY_SEARCH: { value: 57, label: '按搜索结果异步关闭目标数' },
  USER_TAG_BY_CELLPHONE_SHA256: { value: 266, label: '批量标签池操作(按手机号sha256)' },
  BATCH_EXPORT_RECORD_REMARK: { value: 267, label: '录音标记批量导出' },
  BATCH_EXPORT_USER_AUDIT_WORKINFO: { value: 268, label: '按搜索条件导出用户职业信息' },
  BATCH_UPDATE_TASK_AFTER_MARKET_MODIFIED: { value: 269, label: '门店修改后更新任务属性' },
  BATCH_EXPORT_ORDER_SNEAK_SIMILARITY: { value: 270, label: '导出工单抓拍照片对比相似度数据' },
  BATCH_EXPORT_USER_COVERAGE_BY_MARKET_ID: { value: 271, label: '按门店ID批量导出零工覆盖指数' },
  BATCH_EXPORT_USER_COVERAGE_BY_GEO: { value: 272, label: '按经纬度批量导出零工覆盖指数' },
  BATCH_ADD_TAG_BY_CONDITION: { value: 273, label: '按搜索条件查找用户并添加标签' },
  BATCH_DEL_TAG_BY_CONDITION: { value: 274, label: '按搜索条件查找用户并删除标签' },
  BATCH_SUGGEST_PRICE_AND_CREATE_TASK: { value: 276, label: '计算门店任务建议定价并创建任务' },
  BATCH_EXPORT_LOW_SCORE_ORDER_FACE: { value: 280, label: '人脸识别分值导出' },
  BATCH_CREATE_TASK_WITH_TEMPLATE: { value: 281, label: '批量添加任务之替换选模版说明' },
  BATCH_REACTIVE_TASK: { value: 282, label: '批量重新上线任务' },
  BATCH_ORDER_EXPORT_NEW: { value: 283, label: '新版批量导出工单' },
  BATCH_EXPIRE_WORKINFO: { value: 284, label: '批量过期用户职业信息' },
  BATCH_SYNC_PERSONNEL_REQUIREMENT: { value: 285, label: '批量同步批次人员要求到任务' },
  BATCH_TASK_ORDER_EXPORT_NEW: { value: 286, label: '新版批量导出任务工单' },
  BATCH_TASK_EXPORT_NEW: { value: 287, label: '新版批量导出任务' },
  BATCH_BANQUET_TASK_IMPORT: { value: 288, label: '批量导入宴席任务' },
  BATCH_TASK_AUDIT_REFERENCE: { value: 289, label: '上传审核参照数据' }
};

/***/ }),

/***/ 1930:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_task_batch_task_batch_opts__ = __webpack_require__(1527);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _taskTypeOpts,
        _this = this;

    return {
      taskTypeOpts: (_taskTypeOpts = {
        51: '群组门店关联',
        52: '上传群组控制目标数',
        53: '批量上传群组控制目标数',
        54: '群组门店关联(冲突处理)',
        55: '开启关闭群组控制目标数'
      }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_taskTypeOpts, __WEBPACK_IMPORTED_MODULE_3__views_task_batch_task_batch_opts__["a" /* taskTypes */].BATCH_OPEN_TASK_GROUP_BY_SEARCH.value, __WEBPACK_IMPORTED_MODULE_3__views_task_batch_task_batch_opts__["a" /* taskTypes */].BATCH_OPEN_TASK_GROUP_BY_SEARCH.label), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_taskTypeOpts, __WEBPACK_IMPORTED_MODULE_3__views_task_batch_task_batch_opts__["a" /* taskTypes */].BATCH_CLOSE_TASK_GROUP_BY_SEARCH.value, __WEBPACK_IMPORTED_MODULE_3__views_task_batch_task_batch_opts__["a" /* taskTypes */].BATCH_CLOSE_TASK_GROUP_BY_SEARCH.label), _taskTypeOpts),
      batchJobFields: [{
        prop: 'id',
        label: '编号'
      }, {
        prop: 'display_name',
        label: '名称'
      }, {
        prop: 'admin_name',
        label: '创建人'
      }, {
        prop: 'process',
        label: '任务进度',
        formatter: this.formatProcess
      }, {
        prop: 'task_type',
        label: '类型',
        formatter: function formatter(row) {
          return _this.taskTypeOpts[row.task_type];
        }
      }, {
        prop: 'created_at',
        label: '上传时间'
      }, {
        prop: 'status',
        label: '状态',
        formatter: this.formatStatus
      }],
      marketUploadDemoHeader: [{
        key: 'market_id',
        text: '门店ID'
      }, {
        key: 'market_name',
        text: '门店名称'
      }, {
        key: 'group_name_1',
        text: '群组名称1'
      }, {
        key: 'group_name_2',
        text: '群组名称2'
      }, {
        key: 'group_name_3',
        text: '群组名称3'
      }, {
        key: 'group_name_4',
        text: '群组名称4'
      }, {
        key: 'group_name_5',
        text: '群组名称5'
      }],
      importMarketGroupTargetNumHeader: [{
        key: 'group_name',
        text: '群组名称'
      }, {
        key: 'target_num',
        text: '群组目标数'
      }, {
        key: 'task_max_salary',
        text: '任务最大金额/元'
      }],
      batchImportMarketGroupTargetNumHeader: [{
        key: 'group_name',
        text: '群组名称'
      }, {
        key: 'target_num',
        text: '群组目标数'
      }, {
        key: 'task_max_salary',
        text: '任务最大金额/元'
      }, {
        key: 'group_batch_id',
        text: '群组控制批次ID'
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    statusOpts: function statusOpts(state) {
      return state.taskBatch.status;
    }
  })),
  methods: {
    makeObject: function makeObject(data, propKey, valueKey) {
      var result = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var one = _step.value;

          result[one[valueKey]] = one[propKey];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return result;
    },
    formatStatus: function formatStatus(row) {
      var statusOpts = this.makeObject(this.statusOpts, 'label', 'value');
      var result = [statusOpts[row.status]];

      if (row.status * 1 === -2 && row.error_message) {
        result.push(row.error_message);
      }

      return result.join(' ');
    },
    formatProcess: function formatProcess(row) {
      if (Number(row.task_type) === 51) {
        return '\u6210\u529F:' + row.success_count + ' \u51B2\u7A81:' + row.error_count + ' \u603B\u6570:' + row.total_count;
      }
      return '\u6210\u529F:' + row.success_count + ' \u5931\u8D25:' + row.error_count + ' \u603B\u6570:' + row.total_count;
    }
  }
});

/***/ }),

/***/ 2162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* global process */
var adminBase = window._env_.VUE_APP_ADMIN_HOST;

var queryBatchUpload = function queryBatchUpload(params) {
  return axios.post(adminBase + "/excel/query_upload", params);
};
var downSourceFile = function downSourceFile(params) {
  return adminBase + "/excel/down_sourc_file_" + params.id;
};
var downErrorFile = function downErrorFile(params) {
  return adminBase + "/excel/down_error_file_" + params.id;
};
var downUnprocessFile = function downUnprocessFile(params) {
  return adminBase + "/excel/down_unprocess_file_" + params.id;
};
var downExportFile = function downExportFile(params) {
  return adminBase + "/excel/down_export_file_" + params.id;
};
var downEncryptExportFile = function downEncryptExportFile(params) {
  return adminBase + "/batch_jobs/down_encrypt_export_file_" + params.id + ".7z";
};
var cancelTaskBatch = function cancelTaskBatch(params) {
  return axios.post(adminBase + "/excel/cancel_" + params.id, params);
};
var createTaskBatch = function createTaskBatch(params) {
  return axios.post(adminBase + "/excel/create_upload", params);
};
var createExecuteTaskBatch = function createExecuteTaskBatch(params) {
  return axios.post(adminBase + "/excel/create_execute_upload", params);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  queryBatchUpload: queryBatchUpload,
  downSourceFile: downSourceFile,
  downErrorFile: downErrorFile,
  downUnprocessFile: downUnprocessFile,
  downExportFile: downExportFile,
  downEncryptExportFile: downEncryptExportFile,
  cancelTaskBatch: cancelTaskBatch,
  createTaskBatch: createTaskBatch,
  createExecuteTaskBatch: createExecuteTaskBatch
});

/***/ }),

/***/ 2706:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_mixins_table__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Batchjobs_api__ = __webpack_require__(2162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__group_batch_mixins__ = __webpack_require__(1930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_downloadjs__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_downloadjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__core_mixins_table__["b" /* default */], __WEBPACK_IMPORTED_MODULE_2__group_batch_mixins__["a" /* default */]],
  components: {},
  data: function data() {
    return {
      dialogVisible: false,
      search: {
        task_type: [51, 54],
        number: this.$route.params.customerid
      },
      searchFieldType: {
        task_type: Array
      },
      uploadForm: {
        replace_update: false,
        file: null
      }
    };
  },

  computed: {
    relationProjectId: function relationProjectId() {
      return this.$route.params.projectid ? Number(this.$route.params.projectid) : 0;
    }
  },
  methods: {
    getTableData: function getTableData(params) {
      return request.page('queryBatchUpload', filter.copyJson(params));
    },
    resetUploadForm: function resetUploadForm() {
      filter.setLoop(this.uploadForm, {
        replace_update: false,
        file: null
      });
    },
    onSubmitUploadForm: function onSubmitUploadForm() {
      var _this = this;

      if (!this.uploadForm.file) {
        this.$message.error('请上传文件');
        return;
      }

      var formData = new FormData();
      formData.append('file', this.uploadForm.file);
      formData.append('type', '51');
      formData.append('number', this.$route.params.customerid);
      formData.append('params[customer_id]', this.$route.params.customerid);
      formData.append('params[projectid]', this.relationProjectId);
      formData.append('params[replace_update]', Number(this.uploadForm.replace_update));

      request.common('importMarketGroupRelation', formData).then(function () {
        _this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this.dialogVisible = false;
        _this.resetUploadForm();
        _this.$refs['uploader'].clearFiles();
        _this.onRefresh();
      });
    },
    uploadFile: function uploadFile(file) {
      var isLt10M = file.file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!');
        return false;
      }

      this.uploadForm.file = file.file;
    },
    onDownSourceFile: function onDownSourceFile(id) {
      this.$confirm('确认下载文件?', '提示', {
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_3_downloadjs___default()(__WEBPACK_IMPORTED_MODULE_1__components_Batchjobs_api__["a" /* default */].downSourceFile({ id: id }));
      });
    },
    onDownErrorFile: function onDownErrorFile(id) {
      this.$confirm('确认下载?', '提示', {
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_3_downloadjs___default()(__WEBPACK_IMPORTED_MODULE_1__components_Batchjobs_api__["a" /* default */].downErrorFile({ id: id }));
      });
    },

    // conflict_state=2：已执行冲突更新，原冲突文件被挪作强制任务源文件
    isConflictForceUpdated: function isConflictForceUpdated(row) {
      return Number(row.task_type) === 51 && Number((row.params || {}).conflict_state) === 2;
    },
    downloadImportMarketGroupDemo: function downloadImportMarketGroupDemo() {
      this.$export('上传群组门店关系', [{
        'market_id': '769389',
        'market_name': '永辉顺义区后沙峪店',
        'group_name_1': 'A群组',
        'group_name_2': 'B群组',
        'group_name_3': 'C群组',
        'group_name_4': '',
        'group_name_5': ''
      }, {
        'market_id': '769388',
        'market_name': '屈臣氏平湖南城百货）',
        'group_name_1': 'A群组',
        'group_name_2': 'B群组',
        'group_name_3': '',
        'group_name_4': '',
        'group_name_5': ''
      }, {
        'market_id': '温馨提示：【群组名称1】必填、【群组名称2~5】可不填；填写的名称不能重复'
      }], {
        fileHeader: this.marketUploadDemoHeader
      });
    },
    retryMarketGroupRelationConflict: function retryMarketGroupRelationConflict(id) {
      var _this2 = this;

      this.$confirm('确认要执行冲突更新吗?', '提示').then(function () {
        request.common('retryMarketGroupRelationConflictApi', { id: id }).then(function () {
          _this2.onSearch({});
        });
      });
    },
    giveupMarketGroupRelationConflict: function giveupMarketGroupRelationConflict(id) {
      var _this3 = this;

      this.$confirm('确认要放弃冲突更新吗?', '提示').then(function () {
        request.common('giveupMarketGroupRelationConflictApi', { id: id }).then(function () {
          _this3.onSearch({});
        });
      });
    }
  }
});

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupBatchMarketUploadTable_vue__ = __webpack_require__(2706);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76ff6ccf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupBatchMarketUploadTable_vue__ = __webpack_require__(4113);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupBatchMarketUploadTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76ff6ccf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupBatchMarketUploadTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 4113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("群组控制")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('el-dropdown',{attrs:{"split-button":"","type":"primary","size":"small","trigger":"click"},on:{"click":function($event){_vm.dialogVisible = true}}},[_c('span',[_c('i',{staticClass:"el-icon-upload2"}),_vm._v(" 上传群组门店关系")]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"default"},slot:"default"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.downloadImportMarketGroupDemo($event)}}},[_vm._v("下载Demo文件")])],1)],1)],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""}},[_vm._l((_vm.batchJobFields),function(attr){return [(attr.prop === 'display_name')?_c('el-table-column',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-link',{attrs:{"type":"text"},on:{"click":function($event){return _vm.onDownSourceFile(scope.row.id)}}},[_vm._v(_vm._s(scope.row.display_name))])]}}],null,true)},'el-table-column',attr,false)):_c('el-table-column',_vm._b({},'el-table-column',attr,false))]}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('button-gutter',[(scope.row.status === 3 && scope.row.error_count > 0)?[(scope.row.error_count > 0 && !_vm.isConflictForceUpdated(scope.row))?_c('el-button',{attrs:{"type":"text","size":"mini"},on:{"click":function($event){return _vm.onDownErrorFile(scope.row.id)}}},[_vm._v("\n                "+_vm._s(Number(scope.row.task_type) === 51 ? '下载冲突项' : '下载错误行')+"\n              ")]):_vm._e(),_vm._v(" "),(Number(scope.row.task_type) === 51)?[(scope.row.error_count > 0 && !scope.row.params.hasOwnProperty('conflict_state'))?_c('el-button',{attrs:{"type":"text","size":"mini"},on:{"click":function($event){return _vm.retryMarketGroupRelationConflict(scope.row.id)}}},[_vm._v("\n                  执行冲突更新\n                ")]):_vm._e(),_vm._v(" "),(scope.row.error_count > 0 && !scope.row.params.hasOwnProperty('conflict_state'))?_c('el-button',{attrs:{"type":"text","size":"mini"},on:{"click":function($event){return _vm.giveupMarketGroupRelationConflict(scope.row.id)}}},[_vm._v("\n                  放弃冲突更新\n                ")]):_vm._e()]:_vm._e()]:_vm._e()],2),_vm._v(" "),(_vm.isConflictForceUpdated(scope.row))?_c('div',{staticStyle:{"color":"#909399","font-size":"12px","line-height":"1.6","margin-top":"4px","white-space":"normal","word-break":"break-all"}},[_vm._v("\n            冲突文件已用于强制更新，请下载对应「群组门店关联(冲突处理)」任务的源文件\n          ")]):_vm._e()]}}])})],2),_vm._v(" "),_c('div',{staticClass:"pagination margin t10"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[10, 20, 30, 50],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2),_vm._v(" "),_c('el-dialog',{attrs:{"title":"上传门店群组关系","visible":_vm.dialogVisible},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('el-form',{ref:"uploadForm",attrs:{"label-width":"140px","model":_vm.uploadForm},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmitUploadForm($event)}}},[_c('el-form-item',{attrs:{"label":"是否覆盖更新"}},[_c('el-radio-group',{model:{value:(_vm.uploadForm.replace_update),callback:function ($$v) {_vm.$set(_vm.uploadForm, "replace_update", $$v)},expression:"uploadForm.replace_update"}},[_c('el-radio',{attrs:{"label":true}},[_vm._v("是")]),_vm._v(" "),_c('el-radio',{attrs:{"label":false}},[_vm._v("否")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"上传excel文件","required":""}},[_c('el-upload',{ref:"uploader",attrs:{"drag":"","action":"","accept":".xlsx","limit":1,"http-request":_vm.uploadFile}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("将文件拖到此处，或"),_c('em',[_vm._v("点击上传")])]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("只能上传xlsx文件，且不超过5000kb")])])],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("提交表单")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.resetUploadForm}},[_vm._v("重置")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/group-batch-market-upload-table.b68b3c087f51d306f013.js